import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ro from "./locales/ro.json";
import hu from "./locales/hu.json";
import en from "./locales/en.json";

// Full RO/HU/EN translation files. New strings use the t() helper.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: ro },
      hu: { translation: hu },
      en: { translation: en },
    },
    fallbackLng: "ro",
    supportedLngs: ["ro", "hu", "en"],
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
